export default __webpack_public_path__ + "static/media/chevron-right-charcoal.26f4b342.svg";